import React from 'react';

const Services = () => {
  return (
    <div className="container mt-5">
      <h2>Nuestros Servicios</h2>
      <p>Ofrecemos una variedad de servicios para satisfacer tus necesidades:</p>
      <ul>
        <li>Desarrollo Web</li>
        <li>Marketing Digital</li>
        <li>Diseño Gráfico</li>
        {/* Agrega más servicios según sea necesario */}
      </ul>
    </div>
  );
}

export default Services;
